module.exports = __webpack_public_path__ + "img/icon-call-light-white.56ab836e.svg";